export const STEPS = ["Calcola", "Personalizza", "Dati Personali"];

export const INITIAL_VITA_GARANZIE = {
  decesso: {
    enabled: true,
    durata: 10,
    capitale: 40000,
  },
  invalidita: {
    enabled: true,
    durata: 10,
    capitale: 40000,
  },
  malattiaGrave: {
    enabled: false,
    durata: 10,
    capitale: 5000,
  },
  inabilita: {
    enabled: true,
    durata: 10,
    capitale: 1000,
  },
};

export const INITIAL_FORM_DATA = {
  nome: "",
  cognome: "",
  email: "",
  telefono: "",
  codiceFiscale: "",
  dataNascita: "",
  privacyAccettata: false,
};

export const INITIAL_ERRORS = {
  nome: false,
  cognome: false,
  email: false,
  telefono: false,
  dataNascita: false,
  privacyAccettata: false,
};

export const GARANZIE_PREZZI = {
  decesso: 9.41,
  invalidita: 10.45, // 0.83 (infortunio) + 9.62 (malattia)
  malattiaGrave: 0,
  inabilita: 110.14, // 63.88 (infortunio) + 46.26 (malattia)
};

export const GARANZIE_CONFIG = [
  {
    key: "decesso",
    title: "Decesso Accidentale",
    description: "Massimale 40.000€",
    isPrimary: true,
  },
  {
    key: "invalidita",
    title: "Invalidità Totale Permanente",
    description: "Da infortunio e malattia - Massimale 40.000€ condiviso",
    isPrimary: false,
  },
  {
    key: "malattiaGrave",
    title: "Malattia Grave",
    description: "Capitale variabile in base al decesso",
    isPrimary: false,
  },
  {
    key: "inabilita",
    title: "Inabilità Totale Temporanea",
    description: "Da infortunio e malattia - Protezione Reddito, Bollette e Premio",
    isPrimary: false,
  },
];

export const FEATURES = [
  "Piano Platinum - Massima protezione",
  "Linea prodotto 0006",
  "Massimale 40.000€",
  "Copertura completa infortuni e malattie",
];
